/**
 * A query key used to control the adjustment data on the forecast adjustments tab.
 */
export const ADJUSTMENT_TABLE_QUERY = 'adjustmentTableQuery';

/**
 * A query key used to control the key metric data on the forecast summary tab.
 */
export const FORECAST_SUMMARY_KEYMETRIC_QUERY = 'forecastSummaryKeyMetricQuery';
